export default "__VITE_ASSET__L5XhW0Kj__"